interface Props {
  fileSize: number;
  children: (formatted: string) => any;
}

type FileSizeSuffix = 'bytes' | 'KB' | 'MB' | 'GB';
type FileSizeString = `${number}${FileSizeSuffix}`;

const FileSize = ({ fileSize, children }: Props) => {
  const humanize = (fileSize: number): FileSizeString => {
    const giga = 1000 ** 3;
    const mega = 1000 ** 2;
    const kilo = 1000;

    if (fileSize >= giga) {
      return `${Number((fileSize / giga).toFixed(2))}GB`;
    } else if (fileSize >= mega) {
      return `${Number((fileSize / mega).toFixed(2))}MB`;
    } else if (fileSize >= kilo) {
      return `${Number((fileSize / kilo).toFixed(2))}KB`;
    } else {
      return `${fileSize}bytes`;
    }
  };

  return children(humanize(fileSize));
};

export default FileSize;
